<script lang="ts" setup>
import { useTooltip } from '@storefront-ui/vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
});

const label = toRef(props, 'label');
const { isOpen, triggerProps, tooltipProps, arrowProps } = useTooltip();
</script>

<template>
  <span
    v-bind="triggerProps"
    @focus="isOpen = true"
    @blur="isOpen = false"
  >
    <slot />
    <div
      v-if="label && isOpen"
      class="w-max max-w-96 rounded bg-primary-700 px-3 py-1 text-base text-white transition-opacity duration-300"
      v-bind="tooltipProps"
    >
      <span v-html="label" />
      <span
        v-bind="arrowProps"
        class="size-sm rotate-45 bg-primary-700"
      />
    </div>
  </span>
</template>
